// The header checkbox of a table (R-T4, audit 31.10 P2-8): with pages it speaks for the rows of this page only; the rows chosen on
// other pages stay chosen whatever it does.

import type { Id } from '@confdeck/core-shared';

/** What the header checkbox shows for the rows on screen. */
export function pageState(selected: ReadonlySet<Id>, ids: readonly Id[]): boolean | 'mixed' {
  if (ids.length && ids.every((id) => selected.has(id))) return true;
  return selected.size ? 'mixed' : false;
}

/** A click on it: all rows of the page off when all were on, else all on; the other pages keep their choice. */
export function togglePage(selected: ReadonlySet<Id>, ids: readonly Id[]): Set<Id> {
  if (pageState(selected, ids) === true) { const page = new Set(ids); return new Set([...selected].filter((id) => !page.has(id))); }
  return new Set([...selected, ...ids]);
}
